import Bowser from 'bowser';

function parallax(event) {
    document.querySelectorAll('[data-parallax]').forEach(element => {
        const speed = +element.dataset.parallax ?? 0

        const x = (window.innerHeight - event.pageX * speed) / 200,
            y = (window.innerWidth - event.pageY * speed) / 200;

        element.style.transform = `translateX(${x}px) translateY(${y}px)`
    })
}

export function init() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const isMobile = browser.getPlatformType() === 'mobile';

    if (!isMobile) {
        document.addEventListener('mousemove', parallax)
    }
}

export function destroy() {
    document.removeEventListener('mousemove', parallax)
}
